'use client';

import * as LegalFactory from '@/services/legal';
import { Heading, Modal, ModalProps } from '@/ui/components';
import { useEffect, useState } from 'react';

import s from './TermsAndConditions.module.css';

type TermsAndConditionsProps = {
  document: 'terms' | 'privacy';
} & Omit<ModalProps, 'children'>;

const TermsAndConditions = ({ document, ...props }: TermsAndConditionsProps) => {
  const [content, setContent] = useState({
    terms: '',
    privacy: '',
  });

  const getDocuments = async () => {
    const terms = await LegalFactory.getLegalTerms();
    const privacy = await LegalFactory.getLegalPrivacity();

    setContent({
      terms: terms.document,
      privacy: privacy.document,
    });
  };

  useEffect(() => {
    getDocuments();
  }, []);

  return (
    <Modal {...props}>
      {}
      <Heading variant="title3" spacing="small">
        {document === 'terms' ? 'Techbalance Terms of Use' : 'Techbalance Privacy Policy'}
      </Heading>
      <article className={s.content}>{content[document]}</article>
    </Modal>
  );
};

export default TermsAndConditions;
